import React from "react";
import { useState } from "react";

const Counter = () => {
  const [count, setCount] = useState(0);
  console.log("Counter component rendered with count: " + count);
  return (
    <>
      <div>
        <p>Count: {count}</p>
        <button onClick={() => setCount(count + 1)}>Increment</button>
        <button onClick={() => setCount(count - 1)}>Decrement</button>
      </div>
    </>
  );
};

export default Counter;
